import apiClient from './apiClient'

export interface PrimaryPaymentMethod {
  has_payment_method: boolean
  // True when a Direct Debit mandate is set up but the bank hasn't
  // confirmed it yet (ChargeBee status pending_verification).
  pending?: boolean
  label: string | null
}

interface PrimaryPaymentMethodResponse {
  success: boolean
  message: string
  data: PrimaryPaymentMethod | null
}

interface ManagedPageResponse {
  success: boolean
  message: string
  data: { url: string } | null
}

class PaymentMethodService {
  async getPrimary(): Promise<PrimaryPaymentMethod | null> {
    const response = await apiClient.get('/api/auth/payment-methods/primary')
    return (response as unknown as PrimaryPaymentMethodResponse).data || null
  }

  async getManagedPageUrl(): Promise<string> {
    const response = await apiClient.get('/api/auth/payment-methods/managed-page')
    const { data } = response as unknown as ManagedPageResponse
    if (!data?.url) throw new Error('No URL returned from payment management page.')
    return data.url
  }
}

export default new PaymentMethodService()
